(() => {
  if (window.rgAnnouncementSticky) return;
  window.rgAnnouncementSticky = true;
  let observer;
  const sync = () => {
    if (observer) observer.disconnect();
    const bar = document.querySelector('.page-announcement [data-announcement-wrapper]');
    const update = () => document.documentElement.style.setProperty('--rg-announcement-sticky-height', `${bar ? bar.getBoundingClientRect().height : 0}px`);
    if (bar) {
      observer = new ResizeObserver(update);
      observer.observe(bar);
    }
    update();
  };
  sync();
  document.addEventListener('shopify:section:load', sync);
  document.addEventListener('shopify:section:unload', () => requestAnimationFrame(sync));
})();
